import './VideoTutorial.css'
import React, { useState } from 'react';

import logo from '../res/img/AMO_Logo.png';
import {
    Button,
    Grow,
    Box,
    Typography
} from '@material-ui/core';
import {
    Close,
    Videocam,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    GetApp
} from '@material-ui/icons';
import Swal from 'sweetalert2';


const listFile = [
    {
        "link": "https://youtube.com/embed/JMRUJjS7748",
        "name": "บทนำ Amo คืออะไร"
    },
    {
        "link": "https://youtube.com/embed/GjRvsKBNOFI",
        "name": "หลักปฏิบัติ Amo : 1. การลงทะเบียน"
    },
    {
        "link": "https://youtube.com/embed/IzNrWiJP9Zg",
        "name": "หลักปฏิบัติ Amo : 2. การทำภารกิจ การบันทึกและเรียกดูตำแหน่งพิกัด"
    },
    {
        "link": "https://youtube.com/embed/IIW9o7aqhrM",
        "name": "หลักปฏิบัติ Amo : 3.1 การเก็บข้อมูลบุคคล"
    },
    {
        "link": "https://youtube.com/embed/WqAs6Neht90",
        "name": "หลักปฏิบัติ Amo : 3.2 การเก็บข้อมูลยานพาหนะ"
    },
    {
        "link": "https://youtube.com/embed/6-TJGfZV7Ck",
        "name": "หลักปฏิบัติ Amo : 3.3 การเก็บข้อมูลสถานที่"
    },
    {
        "link": "https://youtube.com/embed/iVmiMCs_-EQ",
        "name": "หลักปฏิบัติ Amo : 4. รายงานประจำวัน"
    },
    {
        "link": "https://youtube.com/embed/-TU4pMBY7lE",
        "name": "การใช้งานโหมด เข็มทิศ"
    }
]
function VideoTutorial() {
    const [step, setStep] = useState(0);
    const [link, setLink] = useState(null);
    const [show, setShow] = useState(true);
    const onClickLink = (data) => {
        setStep(1);
        setLink(data);
    }
    const onClickBack = () => {
        setStep(0);
        setLink(null);
    }

    return (
        <div>
                <h1 style={{
                        color: "white",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                }}>Coming Soon</h1>
                <Grow
                    in={show && step === 0}
                    timeout={400}
                    // style={{ display: step !== 0 ? "none" : "block" }}
                    style={{ display: "none "}}
                >
                    <Box padding={3} paddingTop={3} >
                        <img src={logo} alt="AMO" className="video-tutorial-header-logo" />
                        <Typography variant="h5" style={{color:"#ffffff", display:"inline"}}>วีดีโอสอนการใช้งานระบบ AMO</Typography>
                        <Box className="video-tutorial-border">
                            
                        {
                            listFile.map((obj, index) => (
                                <React.Fragment key={index}>
                                    <Box
                                        marginTop={1}
                                        marginBottom={1}
                                        display="flex"
                                        alignItems="center"
                                    >
                                        
                                        <Box
                                            className="cursor-pointer"
                                            display="flex"
                                            alignItems="center"
                                            flex="1 1"
                                            onClick={() => onClickLink(obj)}
                                        >
                                            <Videocam style={{color:"white", marginRight:10}}/> 
                                            <Typography variant="body2" style={{color:"#ffffff"}}>{obj.name}</Typography>
                                            <KeyboardArrowRight className="ml-auto" style={{color:"white"}} />
                                        </Box>
                                    </Box>
                                    {index==listFile.length-1?null:<hr className="video-tutorial-hr"/>}
                                </React.Fragment>
                            ))
                        }
                        </Box>
                    </Box>
                </Grow>
                <Grow
                    in={show && step === 1}
                    style={{ display: step !== 1 ? "none" : "" }}
                >
                    <Box>
                        <Box>
                            <Button  style={{color:"white"}} className="btn-danger" onClick={onClickBack}>
                                <KeyboardArrowLeft style={{color:"white"}}/>
                                กลับ
                            </Button>
                            <Box display="flex" justifyContent="center" flexWrap="wrap" marginTop={2}>
                                <Typography variant="h4">{link?.name ?? ""}</Typography>
                            </Box>
                            <Box display="flex" alignItems="center" justifyContent="center" marginTop={2}>
                                {
                                    (step === 1 && link?.link) ?
                                        <iframe
                                            title={link.name}
                                            type="text/html"
                                            src={link.link}
                                            frameBorder="0"
                                            allowFullScreen
                                            style={{
                                                width: "80%",
                                                maxWidth: "100%",
                                                minWidth: "50%",
                                                maxHeight: "500px",
                                                minHeight: "500px"
                                            }}
                                        />
                                        :
                                        <Box height={200} width="100%" />
                                }
                            </Box>
                        </Box>
                    </Box>
                </Grow>
        </div>
    );
}

export default VideoTutorial;
